import React from 'react';
import { IconButton } from '@material-ui/core';
import TooltipOneComponent from '../TooltipOne/TooltipOne.component';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { NewMessageModal } from '../NewMessage/NewMessageModal.component';
import { useState } from 'react';
import { useScoring } from '../../Context/Scoring.context';
import { fillRed } from '../../utils/contrastSvgAttributes';
import CancelIcon from '@material-ui/icons/Cancel';

interface ISpecialCaseIcons {
  rgzId?: string;
  isSpecialCaseDisabled: boolean;
  cardId?: string;
  isSpecialCaseModalOpen: (value: boolean) => void;
}

export const SpecialCaseIcons: React.FC<ISpecialCaseIcons> = (props) => {
  const [specialCaseModal, setSpecialCaseModal] = useState<{
    open: boolean;
    type: 'standard' | 'helpdesk' | 'specialCase';
  }>({
    open: false,
    type: 'standard',
  });

  const { isSpecialCaseReported, setIsSpecialCaseReported } = useScoring();

  return (
    <>
      {!isSpecialCaseReported ? (
        <TooltipOneComponent title="Zgłoś szczególny przypadek" placement="top">
          <span>
            <IconButton
              disableRipple
              onClick={() => {
                props.isSpecialCaseModalOpen(true);
                setSpecialCaseModal({ open: true, type: 'specialCase' });
              }}
              disabled={props.isSpecialCaseDisabled}
              aria-label="zgłoś szczególny przypadek"
            >
              {props.isSpecialCaseDisabled && (
                <CancelIcon
                  style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    height: '25%',
                    width: '25%',
                    color: 'black',
                  }}
                />
              )}
              <ErrorOutlineIcon />
            </IconButton>
          </span>
        </TooltipOneComponent>
      ) : (
        <TooltipOneComponent title="Szczególny przypadek" placement="top">
          <span>
            <IconButton aria-label="Szczególny przypadek">
              <div style={{ position: 'relative', top: '3px' }}>
                <ErrorOutlineIcon style={{ color: fillRed }} />
              </div>
            </IconButton>
          </span>
        </TooltipOneComponent>
      )}

      <NewMessageModal
        open={specialCaseModal.open}
        type={specialCaseModal.type}
        onClose={() => {
          props.isSpecialCaseModalOpen(false);
          setSpecialCaseModal({ open: false, type: 'specialCase' });
        }}
        onSend={() => {
          setSpecialCaseModal({ open: false, type: 'specialCase' });
          setIsSpecialCaseReported(true);
        }}
        rgzId={props.rgzId}
        cardId={props.cardId}
      ></NewMessageModal>
    </>
  );
};
